import React, { Component } from 'react';
import { Text, Flex, Button, TextField, Divider, RadioButton, Dropdown, IconButton } from 'monday-ui-react-core';
import { Bold, Italic, Underline, Image, Bullets, Numbers, Link, Remove } from "monday-ui-react-core/icons";
import { Heading } from "monday-ui-react-core/next";
import classes from "./create-account.module.scss";
import { createAccount, getAccounts, getFullAccount } from '../../services/backend-service';
import mondaySdk from "monday-sdk-js";
import { valueCreated } from '../../services/hooks';

class CreateAccount extends Component {  
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      displayName: "",
      imapHost: "",
      imapPort: "993",
      imapUser: "",
      imapPass: "",
      imapSecurity: "tls",
      imapFolder: "INBOX",
      smtpHost: "",
      smtpPort: "465",
      smtpUser: "",
      smtpPass: "",
      smtpSecurity: "tls",
      allowedToUseApp: props.allowedToUseApp !== false,
      loading: false,
      createOperation: true,
      isItemsDropdownsLoading: false,
      itemName: null,
      itemId: null,
      itemOptions: [],
      configMode: "simple",
      error: ""
    };
    this.signatureEditorRef = React.createRef();
    this.signatureImageInputRef = React.createRef();
  }

  componentDidMount() {
    const monday = mondaySdk();

    monday.listen("context", (res) => {
      const user = res?.data?.user;
      this.setState({
        allowedToUseApp: !user || !(user.isGuest || user.isViewOnly)
      });
    });
  }

  createAccount() {
    if(!this.state.createOperation && !this.state.itemId) {
      this.setState({
        error: "Please select IMAP account you want to modify"
      });
      return;
    }

    if(!this.state.email.includes("@")) {
      this.setState({
        error: "Please enter a correct e-mail address."
      });
      return;
    }

    let email = this.state.email;

    const folders = (this.state.imapFolder ? this.state.imapFolder : "").split(',').map(f => f.trim()).filter(f => f.length > 0);
    if(folders.length > 5) {
      this.setState({
        error: "You can configure at most 5 folders."
      });
      return;
    }

    const account = {
      itemId: this.state.createOperation ? null : this.state.itemId,
      account: {
        email: email,
        displayName: this.state.displayName,
        configMode: this.state.configMode,
        imap: {
          host: (this.state.configMode === "simple") ? null : this.state.imapHost,
          port: (this.state.configMode === "simple") ? null : this.state.imapPort,
          user: this.state.imapUser,
          pass: this.state.imapPass,
          security: (this.state.configMode === "simple") ? null : this.state.imapSecurity,
          folder: this.state.imapFolder
        },
        smtp: {
          host: (this.state.configMode === "simple") ? null : this.state.smtpHost,
          port: (this.state.configMode === "simple") ? null : this.state.smtpPort,
          user: (this.state.configMode === "simple") ? this.state.imapUser : this.state.smtpUser,
          pass: (this.state.configMode === "simple") ? this.state.imapPass : this.state.smtpPass,
          security: (this.state.configMode === "simple") ? null : this.state.smtpSecurity
        },
        outboundSignatureHtml: this.getOutboundSignatureHtml()
      }
    }

    this.setState({
      loading: true,
      error: ""
    });

    const self = this;
    createAccount(account).then((result) => {
      self.setState({
        loading: false
      });

      if(result.error) {
        this.setState({
          error: result.error
        });
        return;
      }

      valueCreated();

      if(result.backToUrl) {
        window.location.replace(result.backToUrl);
      } else {
        this.setState({
          error: "Your session has expired, please re-create your monday.com board automation"
        });
        return;
      }
    }).catch((error) => {
      self.setState({
        loading: false
      });

      if(error) {
        this.setState({
          error: error
        });
        return;
      }
    })
  }

  async fetchAccounts() {
    this.setState({
      isItemsDropdownsLoading: true
    });

    const data = await getAccounts();
    if(data?.code === 401) {
      this.setState({
        error: "Your session has expired, please re-create your monday.com board automation",
        isItemsDropdownsLoading: false
      });
      return;
    }

    let results = [];
    (data || []).forEach((account) => {
      results.push({
        label: account.title,
        value: account.value
      });
    });

    this.setState({
      itemOptions: results,
      isItemsDropdownsLoading: false
    });
  }

  async fillInAccountDetails(id) {
    this.setState({
      isItemsDropdownsLoading: true
    });

    const account = await getFullAccount(id);
    if(account?.code === 401) {
      this.setState({
        error: "Your session has expired, please re-create your monday.com board automation",
        isItemsDropdownsLoading: false
      });
      return;
    }

    const metadata = account?.metadata || {};
    this.setState({
      itemId: id,
      email: metadata?.email || "",
      displayName: metadata?.displayName || "",
      configMode: metadata?.configMode || "simple",
      imapHost: metadata?.imap?.host || "",
      imapPort: metadata?.imap?.port ? `${metadata.imap.port}` : "993",
      imapUser: metadata?.imap?.user || "",
      imapPass: metadata?.imap?.pass || "",
      imapSecurity: metadata?.imap?.security || "tls",
      imapFolder: metadata?.imap?.folder || "INBOX",
      smtpHost: metadata?.smtp?.host || "",
      smtpPort: metadata?.smtp?.port ? `${metadata.smtp.port}` : "465",
      smtpUser: metadata?.smtp?.user || "",
      smtpPass: metadata?.smtp?.pass || "",
      smtpSecurity: metadata?.smtp?.security || "tls",
      isItemsDropdownsLoading: false
    }, () => this.syncSignatureEditorFromMetadata(metadata?.outboundSignatureHtml));
  }

  async clearSelections() {
    this.setState({
      email: "",
      displayName: "",
      itemName: null,
      itemId: null,
      configMode: "simple",
      imapHost: "",
      imapPort: "993",
      imapUser: "",
      imapPass: "",
      imapSecurity: "tls",
      imapFolder: "INBOX",
      smtpHost: "",
      smtpPort: "465",
      smtpUser: "",
      smtpPass: "",
      smtpSecurity: "tls",
      error: "",
      isItemsDropdownsLoading: false
    }, () => this.syncSignatureEditorFromMetadata(""));
  }

  syncSignatureEditorFromMetadata(html) {
    const el = this.signatureEditorRef.current;
    if (!el) {
      return;
    }
    const next = html || "";
    if (el.innerHTML !== next) {
      el.innerHTML = next;
    }
  }

  getOutboundSignatureHtml() {
    const el = this.signatureEditorRef.current;
    if (!el) {
      return "";
    }
    const html = el.innerHTML || "";
    const textOnly = el.innerText != null ? el.innerText.replace(/\u00a0/g, " ").trim() : "";
    if (!textOnly && !/<img\s/i.test(html)) {
      return "";
    }
    return html;
  }

  signatureToolbarMouseDown(e) {
    e.preventDefault();
  }

  signatureExecCommand(e, command, value = null) {
    e.preventDefault();
    const editor = this.signatureEditorRef.current;
    if (!editor) {
      return;
    }
    editor.focus();
    try {
      document.execCommand(command, false, value);
    } catch (err) {
      /* execCommand unsupported for this command in some browsers */
    }
  }

  openSignatureImagePicker(e) {
    e.preventDefault();
    if (this.signatureImageInputRef.current) {
      this.signatureImageInputRef.current.click();
    }
  }

  onSignatureImageSelected(ev) {
    const file = ev.target.files && ev.target.files[0];
    ev.target.value = "";
    if (!file || !file.type.startsWith("image/")) {
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const editor = this.signatureEditorRef.current;
      if (!editor) {
        return;
      }
      editor.focus();
      const url = reader.result;
      try {
        document.execCommand("insertImage", false, url);
      } catch (err) {
        const img = document.createElement("img");
        img.src = url;
        img.alt = "";
        const sel = window.getSelection();
        if (sel && sel.rangeCount > 0) {
          const range = sel.getRangeAt(0);
          range.deleteContents();
          range.insertNode(img);
        } else {
          editor.appendChild(img);
        }
      }
    };
    reader.readAsDataURL(file);
  }

  normalizeSignatureHref(raw) {
    const trimmed = (raw || "").trim();
    if (!trimmed) {
      return null;
    }
    if (/^javascript:/i.test(trimmed) || /^data:/i.test(trimmed)) {
      return null;
    }
    if (/^https?:\/\//i.test(trimmed) || /^mailto:/i.test(trimmed) || /^tel:/i.test(trimmed)) {
      return trimmed;
    }
    if (trimmed.startsWith("#")) {
      return trimmed;
    }
    if (trimmed.startsWith("//")) {
      return `https:${trimmed}`;
    }
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(trimmed)) {
      return `mailto:${trimmed}`;
    }
    if (!/\s/.test(trimmed) && trimmed.includes(".")) {
      return `https://${trimmed}`;
    }
    return null;
  }

  signatureInsertOrEditLink(e) {
    e.preventDefault();
    const editor = this.signatureEditorRef.current;
    if (!editor) {
      return;
    }
    editor.focus();
    let defaultUrl = "https://";
    const sel = window.getSelection();
    if (sel && sel.rangeCount > 0) {
      let node = sel.anchorNode;
      if (node && node.nodeType === Node.TEXT_NODE) {
        node = node.parentElement;
      }
      const anchor = node && node.closest && node.closest("a");
      if (anchor) {
        const hrefAttr = anchor.getAttribute("href");
        if (hrefAttr) {
          defaultUrl = hrefAttr;
        }
      }
    }
    const input = window.prompt(
      "Enter URL (https://, mailto:, tel:, or #anchor). Select text first to use as the link label.",
      defaultUrl
    );
    if (input === null) {
      return;
    }
    const href = this.normalizeSignatureHref(input);
    if (!href) {
      return;
    }
    try {
      document.execCommand("createLink", false, href);
    } catch (err) {
      /* createLink unsupported */
    }
  }

  signatureRemoveLink(e) {
    e.preventDefault();
    const editor = this.signatureEditorRef.current;
    if (!editor) {
      return;
    }
    editor.focus();
    try {
      document.execCommand("unlink", false, null);
    } catch (err) {
      /* unlink unsupported */
    }
  }

  cancel() {
    const filters = {
      cancel: true
    }

    createAccount(filters).then((result) => {
      if(result.error) {
        this.setState({
          error: result.error
        });
        return;
      }

      if(result.backToUrl) {
        window.location.replace(result.backToUrl);
      } else {
        this.setState({
          error: "Your session has expired, please re-create your monday.com board automation"
        });
        return;
      }
    }).catch((error) => {
      if(error) {
        this.setState({
          error: error
        });
        return;
      }
    })
  }

  handleValueChange(value, type) {
    if(type === "imapHost") {
      this.setState({
        imapHost: value
      });
    } else if(type === "imapPort") {
      this.setState({
        imapPort: value
      });
    } else if(type === "imapUser") {
      this.setState({
        imapUser: value
      });
    } else if(type === "imapPass") {
      this.setState({
        imapPass: value
      });
    } else if(type === "imapFolder") {
      this.setState({
        imapFolder: value
      });
    } else if(type === "smtpHost") {
      this.setState({
        smtpHost: value
      });
    } else if(type === "smtpPort") {
      this.setState({
        smtpPort: value
      });
    } else if(type === "smtpUser") {
      this.setState({
        smtpUser: value
      });
    } else if(type === "smtpPass") {
      this.setState({
        smtpPass: value
      });
    } else if(type === "email") {
      this.setState({
        email: value,
        smtpUser: value,
        imapUser: value
      });
    } else if(type === "displayName") {
      this.setState({
        displayName: value
      });
    }
  }

  render() {
    return (
      <Flex align={Flex.align.CENTER} gap={Flex.gaps.LARGE} direction={Flex.directions.COLUMN} justify={Flex.justify.CENTER} className={classes.container}>
        <Flex align={Flex.align.CENTER} gap={Flex.gaps.SMALL} direction={Flex.directions.COLUMN}>
            <img className={classes.emptySetImg} alt="Connect Account" src="/monday/imap/v1/config/images/logo.png" />
            <Heading type={Heading.types.H2}>Connect Account</Heading>
            <Text type={Text.types.TEXT1}>Please enter your IMAP/SMTP connection settings</Text>
            <Text type={Text.types.TEXT1} className={classes.errorMessage}>{this.state.error}</Text>
        </Flex>
        <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.COLUMN}>
          <Text type={Text.types.TEXT1}>What operation do you want to perform?</Text>
          <Flex align={Flex.align.CENTER} gap={Flex.gaps.MEDIUM} direction={Flex.directions.ROW}>
            <RadioButton
              text="Create new"
              name="operation-group"
              checked={this.state.createOperation}
              onSelect={async () => {
                await this.clearSelections();
                this.setState({createOperation: true});
              }}
            />
            <RadioButton
              text="Update existing"
              name="operation-group"
              checked={!this.state.createOperation}
              onSelect={async () => {
                await this.clearSelections();
                this.setState({createOperation: false});
                this.fetchAccounts();
              }}
            />
          </Flex>
          {(!this.state.createOperation)
          ? <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.COLUMN} className={classes.fullWidth}>
            <Text type={Text.types.TEXT1}>Select the IMAP account you want to modify</Text>
            <Dropdown
              className={classes.fullWidth}
              placeholder="Select an account"
              isLoading={this.state.isItemsDropdownsLoading}
              value={{label: this.state.itemName, value: this.state.itemId}}
              onChange={(e) => {
                this.setState({
                  itemName: e ? e.label : null,
                  itemId: e ? e.value : null
                });

                if(e?.value) {
                  this.fillInAccountDetails(e.value);
                }
              }}
              options={this.state.itemOptions}
            />
          </Flex>
          : <div></div>}
          <TextField 
            size={TextField.sizes.MEDIUM} 
            required={true}
            title='Email Address'
            maxLength={150}
            value={this.state.email}
            onChange={(value) => { 
              this.handleValueChange(value, "email") 
            }}/>
          <TextField 
            size={TextField.sizes.MEDIUM} 
            required={false}
            title='Display Name'
            maxLength={150}
            value={this.state.displayName}
            onChange={(value) => { 
              this.handleValueChange(value, "displayName") 
            }}/>
          <Flex align={Flex.align.CENTER} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW}>
            <Text type={Text.types.TEXT2}>Configuration Mode:</Text>
            <RadioButton text="Simple" name="config-group" checked={this.state.configMode === "simple"} onSelect={() => { this.setState({configMode: "simple"}) }} />
            <RadioButton text="Advanced" name="config-group" checked={this.state.configMode === "advanced"} onSelect={() => { this.setState({configMode: "advanced"}) }} />
          </Flex>
          {(this.state.configMode === "advanced") 
          ? <Text type={Text.types.TEXT1} className={classes.dividerText}>Inbound Settings</Text>
          : <div></div>
          }
          {(this.state.configMode === "advanced") 
          ? <Divider/>
          : <div></div>
          }
          <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW}>
            <TextField 
              size={TextField.sizes.MEDIUM} 
              required={true}
              title='IMAP Username'
              value={this.state.imapUser}
              onChange={(value) => { 
                this.handleValueChange(value, "imapUser") 
              }}/>
            <TextField 
                size={TextField.sizes.MEDIUM} 
                maxLength={50}
                type={TextField.types.PASSWORD}
                required={true}
                title='IMAP Password'
                value={this.state.imapPass}
                onChange={(value) => { 
                  this.handleValueChange(value, "imapPass") 
                }}/>
          </Flex>
          {(this.state.configMode === "advanced") 
          ? <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.COLUMN} className={classes.fullWidth}>
            <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW}>
              <TextField 
                size={TextField.sizes.MEDIUM} 
                required={true}
                title='IMAP Incoming Server'
                value={this.state.imapHost}
                onChange={(value) => { 
                  this.handleValueChange(value, "imapHost") 
                }}/>
              <TextField 
                size={TextField.sizes.MEDIUM} 
                required={true}
                title='Port'
                value={this.state.imapPort}
                type={TextField.types.NUMBER}
                onChange={(value) => { 
                  this.handleValueChange(value, "imapPort")  
                }}/>
            </Flex>
            <Flex align={Flex.align.CENTER} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW}>
              <Text type={Text.types.TEXT2}>Security:</Text>
              <RadioButton text="TLS" name="imap-security-group" checked={this.state.imapSecurity === "tls"} onSelect={() => { this.setState({imapSecurity: "tls", imapPort: "993"}) }} />
              <RadioButton text="StartTLS" name="imap-security-group" checked={this.state.imapSecurity === "starttls"} onSelect={() => { this.setState({imapSecurity: "starttls", imapPort: "143"}) }} />
              <RadioButton text="None" name="imap-security-group" checked={this.state.imapSecurity === "none"} onSelect={() => { this.setState({imapSecurity: "none", imapPort: "143"}) }} />
            </Flex>
            <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.COLUMN} className={classes.fullWidth}>
              <TextField 
                size={TextField.sizes.MEDIUM} 
                required={true}
                title='Folder'
                value={this.state.imapFolder}
                className={classes.fullWidth}
                onChange={(value) => { 
                  this.handleValueChange(value, "imapFolder") 
                }}/>
              <Text type={Text.types.TEXT2} >
                Folder(s) to scan for incoming messages. Default is INBOX.<br/>
                You can enter multiple folders separated by commas, e.g.,<br/>
                INBOX,INBOX.Sent
              </Text>
            </Flex>
            <Text type={Text.types.TEXT1} className={classes.dividerText}>Outbound Settings</Text>
            <Divider/>
            <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW}>
              <TextField 
                size={TextField.sizes.MEDIUM} 
                required={true}
                title='SMTP Username'
                value={this.state.smtpUser}
                onChange={(value) => { 
                  this.handleValueChange(value, "smtpUser") 
                }}/>
              <TextField 
                  size={TextField.sizes.MEDIUM} 
                  maxLength={50}
                  type={TextField.types.PASSWORD}
                  required={true}
                  title='SMTP Password'
                  value={this.state.smtpPass}
                  onChange={(value) => { 
                    this.handleValueChange(value, "smtpPass")  
                }}/>
            </Flex>
            <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW}>
              <TextField 
                size={TextField.sizes.MEDIUM} 
                required={true}
                title='SMTP Outgoing Server'
                value={this.state.smtpHost}
                onChange={(value) => { 
                  this.handleValueChange(value, "smtpHost") 
                }}/>
              <TextField 
                size={TextField.sizes.MEDIUM} 
                required={true}
                title='Port'
                value={this.state.smtpPort}
                type={TextField.types.NUMBER}
                onChange={(value) => { 
                  this.handleValueChange(value, "smtpPort") 
                }}/>
            </Flex>
            <Flex align={Flex.align.CENTER} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW}>
              <Text type={Text.types.TEXT2}>Security:</Text>
              <RadioButton text="TLS" name="smtp-security-group" checked={this.state.smtpSecurity === "tls"} onSelect={() => { this.setState({smtpSecurity: "tls", smtpPort: "465"}) }} />
              <RadioButton text="StartTLS" name="smtp-security-group" checked={this.state.smtpSecurity === "starttls"} onSelect={() => { this.setState({smtpSecurity: "starttls", smtpPort: "587"}) }} />
              <RadioButton text="None" name="smtp-security-group" checked={this.state.smtpSecurity === "none"} onSelect={() => { this.setState({smtpSecurity: "none", smtpPort: "25"}) }} />
            </Flex>
            <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.COLUMN} className={classes.fullWidth}>
              <div className={classes.signatureField}>
                <label className={classes.signatureLabel} htmlFor="outbound-signature-editor">
                  E-mail signature (outbound)
                </label>
                <Flex
                  align={Flex.align.CENTER}
                  gap={Flex.gaps.SMALL}
                  direction={Flex.directions.ROW}
                  className={classes.signatureToolbar}
                  onMouseDown={this.signatureToolbarMouseDown.bind(this)}
                >
                  <IconButton
                    icon={Bold}
                    kind="tertiary"
                    size={IconButton.sizes.SMALL}
                    ariaLabel="Bold"
                    tooltipContent="Bold"
                    onClick={(e) => this.signatureExecCommand(e, "bold")}
                  />
                  <IconButton
                    icon={Italic}
                    kind="tertiary"
                    size={IconButton.sizes.SMALL}
                    ariaLabel="Italic"
                    tooltipContent="Italic"
                    onClick={(e) => this.signatureExecCommand(e, "italic")}
                  />
                <IconButton
                  icon={Underline}
                  kind="tertiary"
                  size={IconButton.sizes.SMALL}
                  ariaLabel="Underline"
                  tooltipContent="Underline"
                  onClick={(e) => this.signatureExecCommand(e, "underline")}
                />
                <IconButton
                  icon={Link}
                  kind="tertiary"
                  size={IconButton.sizes.SMALL}
                  ariaLabel="Link"
                  tooltipContent="Link (select text, then set URL)"
                  onClick={(e) => this.signatureInsertOrEditLink(e)}
                />
                <IconButton
                  icon={Remove}
                  kind="tertiary"
                  size={IconButton.sizes.SMALL}
                  ariaLabel="Remove link"
                  tooltipContent="Remove link"
                  onClick={(e) => this.signatureRemoveLink(e)}
                />
                <IconButton
                  icon={Bullets}
                    kind="tertiary"
                    size={IconButton.sizes.SMALL}
                    ariaLabel="Bulleted list"
                    tooltipContent="Bulleted list"
                    onClick={(e) => this.signatureExecCommand(e, "insertUnorderedList")}
                  />
                  <IconButton
                    icon={Numbers}
                    kind="tertiary"
                    size={IconButton.sizes.SMALL}
                    ariaLabel="Numbered list"
                    tooltipContent="Numbered list"
                    onClick={(e) => this.signatureExecCommand(e, "insertOrderedList")}
                  />
                  <IconButton
                    icon={Image}
                    kind="tertiary"
                    size={IconButton.sizes.SMALL}
                    ariaLabel="Insert image"
                    tooltipContent="Insert image"
                    onClick={(e) => this.openSignatureImagePicker(e)}
                  />
                </Flex>
                <input
                  ref={this.signatureImageInputRef}
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={this.onSignatureImageSelected.bind(this)}
                />
                <div
                  id="outbound-signature-editor"
                  ref={this.signatureEditorRef}
                  className={classes.signatureEditor}
                  contentEditable={this.state.allowedToUseApp}
                  suppressContentEditableWarning
                  aria-multiline="true"
                  role="textbox"
                />
              <Text type={Text.types.TEXT2} className={classes.signatureHelp}>
                Rich text, hyperlinks, and inline images are supported (including paste from other apps). Use Link after selecting the text you want to show. Images are stored with the account as part of the signature.
              </Text>
              </div>
            </Flex>
          </Flex>
          : <div></div>
          }
        </Flex>
        <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW} justify={Flex.justify.CENTER} className={classes.fullWidth}>
          <Button 
            size={Button.sizes.MEDIUM} 
            kind={Button.kinds.PRIMARY}
            loading={this.state.loading}
            onClick={() => {
              this.createAccount();
            }}
          >
            {this.state.createOperation ? "Create Account" : "Update Account"}
          </Button>
          <Button 
            size={Button.sizes.MEDIUM} 
            kind={Button.kinds.SECONDARY}
            disabled={this.state.loading}
            onClick={() => {
              this.cancel();
            }}
          >
            Cancel
          </Button>
        </Flex>
      </Flex>
    );
  }
}

export default CreateAccount;
